import getConfig from 'next/config'

export const getAppConfig = () => {
  const { publicRuntimeConfig } = getConfig()
  return publicRuntimeConfig
}
